// Module
var code = `<div class="js-collapse-link" style="{{>position}}"
	on-mouseover="mouseOver"
	on-mouseleave="mouseLeave"
	on-click="click">
	<div class="js-text" style="color:{{.color}}">{{.text}}</div>
	<div class="js-image" style="background-image:url({{.image}})"></div>
</div>`;
// Exports
export default code;